import React from "react";
import AlertSummary from "alerts/alert_summary/AlertSummary";
import AccountAlerts from "alerts/account_alerts/AccountAlerts";

class Alerts extends React.Component {
	constructor(props) {
		super(props);
	}

	snoozeAlert = (alertId, daysToSnooze, scriptName) => {
		var daysToSnooze = parseInt(daysToSnooze) || 0;
		if (daysToSnooze > 0) {
			$.ajax({
				type: "PATCH",
				url: "/datapulse/alerts/snooze/" + alertId,
				data: {
					id: alertId,
					days_to_snooze: daysToSnooze,
					script_name: scriptName,
				},
			});
		}
	};

	resolveAlert = (alertId, resolved) => {
		$.ajax({
			type: "PATCH",
			url: "/datapulse/alerts/" + alertId,
			data: {
				id: alertId,
				resolved: resolved,
				resolved_by: this.props.userEmail,
			},
		});
	};

	resolveAll = (ids, refresh, redirectUrl) => {
		$.ajax({
			type: "GET",
			url: "/datapulse/resolve-all",
			data: {
				alert_ids: ids,
				refresh: refresh,
				redirect_url: redirectUrl,
			},
		});
	};

	render() {
		let AlertView;
		if (this.props.view == "account_alerts") {
			AlertView = AccountAlerts;
		} else if (this.props.view == "alert_summary") {
			AlertView = AlertSummary;
		}
		return (
			<AlertView
				{...this.props}
				snoozeAlert={this.snoozeAlert}
				resolveAlert={this.resolveAlert}
				resolveAll={this.resolveAll}
			/>
		);
	}
}

export default Alerts;
